import { Pipe, PipeTransform } from '@angular/core';

import {IntegrationTask} from '@app/views/admin/application-settings/models/integration-task.model';
import {ApplicationSettingsService} from '@app/views/admin/application-settings/application-settings.service';

@Pipe({
    name: 'ngcIntegrationTaskVisibilityPipe'
})
export class IntegrationTaskVisibilityPipe implements PipeTransform {

    transform(integrationTasks: IntegrationTask[], pageVisibleTasksList: IntegrationTask[], eduToneDS: string): IntegrationTask[] {
        return (integrationTasks || []).filter((task: IntegrationTask) =>
            pageVisibleTasksList.some((intTask: IntegrationTask) => task[`${eduToneDS}Type`] === intTask[`${eduToneDS}Type`]));
    }
}
